






































































































































































import Vue from 'vue';

const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
const csrfToken = document.cookie.split(';').find((c) => c.startsWith('csrftoken='))?.split('=')[1] ?? '';

interface Account {
  selected?: boolean;
  account_code: string;
  account_name: string;
  id: number;
  account_id?: number;
  // earliest_consignment?: string;
  // latest_consignment?: string;
}

type AccountProperty = 'account_code' | 'account_name';

interface Customer {
  id: string;
  name: string;
  depot: string;
  start_date: string;
  sales_person_id: number;
  pledge_pallets_per_week: number;
  selected: boolean;
  accounts: Account[];
}

export default Vue.extend({
  name: 'JhlAdmin',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      customers: [] as Customer[],
      filteredCustomers: [] as Customer[],
      accounts: [],
      customerName: '',
      salesperson: 'none',
      salespersons: [],
      depot: '',
      pledgePalletsPerWeek: 0 as number | string,
      errors: {
        wrongCredentials: false,
        zeroPledges: [] as string[],
        accountMissing: false,
        customerNameMissing: false,
        salespersonMissing: false,
        depotMissing: false,
        pledgePalletsMissing: false,
        pledgePalletsNotNumber: false,
      },
      searchCustomerParams: {
        value: '',
        category: 'all' as 'all' | 'name',
        caseInsensitive: false,
      },
      searchParams: {
        value: '',
        category: 'all' as AccountProperty | 'all',
        caseInsensitive: false,
      },
      filteredAccounts: [] as Account[],
      success: '',
      fail: false,
      columnSorted: '',
      selectedAccounts: [] as Account[],
      selectedCustomer: null as string | null,
      isStaff: false,
    };
  },
  async mounted() {
    await this.getIsStaff();

  },
  watch: {
    pledgePalletsPerWeek(newValue) {
      const parsedValue = this.pledgePalletsPerWeek = parseInt(newValue, 10);
      if (Number.isNaN(parsedValue)) {
        this.errors.pledgePalletsNotNumber = true;
        this.pledgePalletsPerWeek = newValue;
      } else {
        this.errors.pledgePalletsNotNumber = false;
      }
    },
    success() {
      setTimeout(() => this.success = '', 2000);
    },
  },
  methods: {
    async handleLogout() {
      await fetch(`${BASE_URL}/jhl-admin-api/log-out/`, {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'X-CSRFToken': csrfToken,
        },
      });
      await this.getIsStaff();

    },
    async login() {
      const body = {
        username: this.username.trim(),
        password: this.password.trim(),
      };
      const response = await fetch(`${BASE_URL}/jhl-admin-api/log-in/`, {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify(body),
      });
      const parsedResponse = await response.json();
      if (parsedResponse.isLoggedIn) {
        this.errors.wrongCredentials = false;
        // Because Django passes a new token after login
        window.location.reload();
      } else {
        this.errors.wrongCredentials = true;
      }
    },
    async handleDeleteCustomer(customer: Customer) {
      const accountsIds: number[] = [];
      customer.accounts.map((a) => {
        accountsIds.push(a.id);
      });
      const body = {
        customerId: customer.id,
        accountsIds,
      };
      await fetch(`${BASE_URL}/jhl-admin-api/delete-customer/`, {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify(body),
      });
      await this.getAccounts();
      await this.getCustomers();
    },
    async getIsStaff() {
      await fetch(`${BASE_URL}/jhl-admin-api/is-staff/`, {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'X-CSRFToken': csrfToken,
        },
      })
          .then(async (response) => {
            const parsedResponse = await response.json();
            this.isStaff = parsedResponse.isStaff;
            if (this.isStaff) {
              await this.getCustomers();
              await this.getAccounts();
              await fetch(`${BASE_URL}/jhl-admin-api/salespersons`, {
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/json',
                  'Access-Control-Allow-Credentials': 'true',
                  'X-CSRFToken': csrfToken,
                },
              })
                  .then(async (responseInner) => {
                    const parsedResponseInner = await responseInner.json();
                    this.salespersons = parsedResponseInner.salespersons;
                  })
              ;
            }
          });
    },
    async getCustomers() {
      await fetch(`${BASE_URL}/jhl-admin-api/customers`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'X-CSRFToken': csrfToken,
        },
      })
          .then(async (response) => {
            const parsedResponse = await response.json();
            this.customers = parsedResponse.customers;
            this.filteredCustomers = parsedResponse.customers;
            this.loading = false;
          });
      this.search();
      this.searchCustomer();
    },
    async getAccounts() {
      await fetch(`${BASE_URL}/jhl-admin-api/accounts`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'X-CSRFToken': csrfToken,
        },
      })
          .then(async (response) => {
            const parsedResponse = await response.json();
            this.accounts = parsedResponse.accounts;
            this.filteredAccounts = parsedResponse.accounts;
          });
      this.search();
      this.searchCustomer();
    },
    handleSelectedCustomer(id: string) {
      this.selectedAccounts = [];
      if (this.selectedCustomer === null) {
        this.selectedCustomer = id;
      } else {
        this.selectedCustomer = null;
      }
    },
    handleAddSelectedAccount(id: number, event: Event) {
      if (this.selectedCustomer !== null) {
        event.preventDefault();
        const body = {
          case: 'add',
          customerId: this.selectedCustomer,
          accountId: id,
        };
        fetch(`${BASE_URL}/jhl-admin-api/update-customer-accounts/`, {
          method: 'post',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': 'true',
            'X-CSRFToken': csrfToken,
          },
          body: JSON.stringify(body),
        });
        this.getCustomers();
        this.getAccounts();
      }
    },
    handleRemoveSelectedAccount(accountId: number, existingCustomer: boolean, customerId?: number) {
      if (!existingCustomer) {
        // Remove form customer to add (no DB involved)
        this.selectedAccounts = this.selectedAccounts.filter((a: Account) => a.id !== accountId);
      } else {
        // Remove to currently selected customer
        const body = {
          case: 'remove',
          customerId,
          accountId,
        };
        fetch(`${BASE_URL}/jhl-admin-api/update-customer-accounts/`, {
          method: 'post',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': 'true',
            'X-CSRFToken': csrfToken,
          },
          body: JSON.stringify(body),
        });
        this.getCustomers();
        this.getAccounts();
      }
    },
    async updateField(id: string, event: Event) {
      const target = event.target && event.target;
      const value = (target as HTMLButtonElement).value;
      if (parseInt(value, 0) !== 0) {
        this.errors.zeroPledges = this.errors.zeroPledges.filter((customerId: string) => customerId !== id);
        const body = {
          id,
          fieldName: (target as HTMLButtonElement).id,
          value,
        };
        await fetch(`${BASE_URL}/jhl-admin-api/customers/`, {
          method: 'post',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': 'true',
            'X-CSRFToken': csrfToken,
          },
          body: JSON.stringify(body),
        });
        await this.getCustomers();
      } else {
        this.errors.zeroPledges.push(id);
      }
    },
    sort(id: string, fieldName: AccountProperty) {
      const chevronToUpdate = document.getElementById(id);
      if (chevronToUpdate?.innerText === '˅') {
        chevronToUpdate.innerText = '˄';
        this.filteredAccounts = this.filteredAccounts.sort((a, b) => {
          if (a[fieldName] > b[fieldName]) {
            this.columnSorted = fieldName;
            return -1;
          }
          if (a[fieldName] < b[fieldName]) {
            this.columnSorted = fieldName;
            return 1;
          }
          this.columnSorted = fieldName;
          return 0;
        });
      } else {
        if (chevronToUpdate) {
          chevronToUpdate.innerText = '˅';
        }
        this.filteredAccounts = this.filteredAccounts.sort((a, b) => {
          if (a[fieldName] < b[fieldName]) {
            this.columnSorted = fieldName;
            return -1;
          }
          if (a[fieldName] > b[fieldName]) {
            this.columnSorted = fieldName;
            return 1;
          }
          this.columnSorted = fieldName;
          return 0;
        });
      }
    },
    searchCustomer() {
      if (this.searchCustomerParams.value === '') {
        return (this.filteredCustomers = this.customers);
      }
      this.filteredCustomers = [];
      this.customers.map((c: Customer) => {
        if (this.searchCustomerParams.category === 'all') {
          Object.values(c).some((v) => {
            if (this.searchCustomerParams.caseInsensitive) {
              return typeof v === 'string' && v.toLowerCase()
                      .includes(this.searchCustomerParams.value.toLowerCase())
                  && this.filteredCustomers.push(c);
            }
            return typeof v === 'string' && v
                    .includes(this.searchCustomerParams.value)
                && this.filteredCustomers.push(c);
          });
        } else {
          if (this.searchCustomerParams.caseInsensitive) {
            return c[this.searchCustomerParams.category].toLowerCase()
                    .includes(this.searchCustomerParams.value.toLowerCase())
                && this.filteredCustomers.push(c);
          }
          return c[this.searchCustomerParams.category]
                  .includes(this.searchCustomerParams.value)
              && this.filteredCustomers.push(c);
        }
      });
    },
    search() {
      if (this.searchParams.value === '') {
        return (this.filteredAccounts = this.accounts);
      }
      this.filteredAccounts = [];
      this.accounts.map((a: Account) => {
        if (this.searchParams.category === 'all') {
          Object.values(a).some((v) => {
            if (this.searchParams.caseInsensitive) {
              return typeof v === 'string' && v.toLowerCase().includes(this.searchParams.value.toLowerCase()) &&
                  this.filteredAccounts.push(a);
            }
            return typeof v === 'string' && v.includes(this.searchParams.value) && this.filteredAccounts.push(a);
          });
        } else {
          if (this.searchParams.caseInsensitive) {
            return a[this.searchParams.category].toLowerCase().includes(this.searchParams.value.toLowerCase()) &&
                this.filteredAccounts.push(a);
          }
          return a[this.searchParams.category].includes(this.searchParams.value) && this.filteredAccounts.push(a);
        }
      });
    },
    resetFormFields() {
      this.selectedAccounts = [];
      this.customerName = '';
      this.salesperson = 'none';
      this.depot = 'none';
      this.pledgePalletsPerWeek = 0;
    },
    handleConfirm() {
      this.errors.accountMissing = false;
      this.errors.customerNameMissing = false;
      this.errors.salespersonMissing = false;
      this.errors.depotMissing = false;
      this.errors.pledgePalletsMissing = false;
      if (this.selectedAccounts.length === 0) {
        return this.errors.accountMissing = true;
      }
      if (this.customerName === '') {
        return this.errors.customerNameMissing = true;
      }
      if (this.salesperson === 'none') {
        return this.errors.salespersonMissing = true;
      }
      if (this.depot === '') {
        return this.errors.depotMissing = true;
      }
      if (this.pledgePalletsPerWeek === 0) {
        return this.errors.pledgePalletsMissing = true;
      }
      if (this.errors.pledgePalletsNotNumber) {
        return;
      }
      const body = {
        selectedAccounts: this.selectedAccounts,
        customerName: this.customerName,
        salesperson: this.salesperson,
        depot: this.depot,
        pledgePalletsPerWeek: this.pledgePalletsPerWeek,
      };


      fetch(`${BASE_URL}/jhl-admin-api/create-customer/`, {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify(body),
      })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.status === 'success') {
              this.resetFormFields();
              await this.getAccounts();
              await this.getCustomers();
              this.fail = false;
              return this.success = data.customer;
            }
            return this.fail = true;
          });
    },
  },
});
